import * as React from 'react';
import { useTranslation } from 'react-i18next';

import DropArea from '../../../../core/components/DropArea.tsx';
import FormField from '../../../../core/components/FormField.tsx';

interface EmlUploadFormProps {
    files: File[];
    onFilesChange: (files: File[]) => void;
}

/** The .eml email file to test an agent with. */
const EmlUploadForm = ({ files, onFilesChange }: EmlUploadFormProps) => {
    const { t } = useTranslation('assistants', { keyPrefix: 'agentConfig' });

    return (
        <FormField label={t('uploadModal.fileLabel')} helpText={t('uploadModal.fileHelpText')}>
            <DropArea
                placeholder={t('uploadModal.dropPlaceholder')}
                placeholderActive={t('uploadModal.dropPlaceholderActive')}
                placeholderInvalid={t('uploadModal.dropPlaceholderInvalid')}
                onFilesChange={onFilesChange}
                files={files}
                maxFiles={1}
                accept={{
                    'message/rfc822': ['.eml'],
                }}
            />
        </FormField>
    );
};

export default EmlUploadForm;
